export const ROUTER_EDITEAZA_VEHICULE = {
  routes: ["/", "/logs", "*"],
};

export const VEHICLE_OPTIONS_EDIT_SOLD_VEHICLE = {
  editSoldVehicle: true,
};
